import SingleClientReportDetailsTable from './SingleClientReportDetailsTable';

export default SingleClientReportDetailsTable;


// WEBPACK FOOTER //
// ./src/features/reports/components/single-client-details/client-info-table/index.js